<button mat-raised-button color="primary" [matMenuTriggerFor]="reportMenu">
    <mat-icon>arrow_drop_down</mat-icon>
    &nbsp;Reports
</button>
<mat-menu #reportMenu="matMenu">
    <button
        mat-menu-item
        [disabled]="cannotDownloadDraftSchedule()"
        (click)="lot.generateDraftCreateSchedule().pipe(take(1)).subscribe()"
    >
        Draft Create Schedule
    </button>
    @if (canViewHLFlyer) {
        <button
            mat-menu-item
            [disabled]="!isHLFlyerButtonEnabled"
            (click)="lot.generateHLFlyer().pipe(take(1)).subscribe()"
        >
            H&L Flyer
        </button>
    }
    <button
        mat-menu-item
        (click)="lot.generateColourYourDreams().pipe(take(1)).subscribe()"
        [disabled]="!lot.canGenerateColourYourDreams"
    >
        Color Schedule
    </button>
    <button mat-menu-item (click)="lot.generatePropertyInformation().pipe(take(1)).subscribe()">
        Property Information
    </button>
    <button
        mat-menu-item
        (click)="lot.generateClientPropertyInformation().pipe(take(1)).subscribe()"
    >
        Client Property Information
    </button>
    <button
        mat-menu-item
        (click)="generateSiteEvaluation()"
        [disabled]="!lot.canGenerateLeadSiteEvaluationForm"
    >
        Site Evaluation Form
    </button>
    <button mat-menu-item (click)="lot.generateLotSpecReport().pipe(take(1)).subscribe()">
        Lot Spec Report
    </button>
    @if (lot.hasScheduleSpecTemplate) {
        <button
            mat-menu-item
            (click)="lot.generateCostXItemsReport().pipe(take(1)).subscribe()"
            [disabled]="!currentUser.isQSTeam()"
        >
            CostX Items
        </button>
    }
    <button
        mat-menu-item
        (click)="lot.generateFinalLotSpec().pipe(take(1)).subscribe()"
        [disabled]="!lot.canGenerateLiveSchedule"
    >
        Live Schedule
    </button>
    <button
        mat-menu-item
        [disabled]="!lot.isDesignAndBuild"
        (click)="lot.generateCreateBookCoverPage1().pipe(take(1)).subscribe()"
    >
        Create Book Cover Page I
    </button>
    <button
        mat-menu-item
        [disabled]="!lot.isDesignAndBuild"
        (click)="lot.generateCreateBookCoverPage2().pipe(take(1)).subscribe()"
    >
        Create Book Cover Page II
    </button>
    <button
        mat-menu-item
        [disabled]="!lot.isDesignAndBuild"
        (click)="lot.generateDesignAndBuildContractLetter().pipe(take(1)).subscribe()"
    >
        Design and Build Contract Letter
    </button>
    <button mat-menu-item (click)="downloadPricingTemplate()">Pricing Template</button>
</mat-menu>
